<div class="p-2 p-lg-3 app-form-shell">
  <div class="d-flex justify-content-between align-items-center border-bottom pb-2 mb-2">
    <div class="d-flex align-items-center gap-2">
      <span class="icon-pill" style="width:30px;height:30px;background:#d8e9ff;color:#2267c7">
        <lucide-icon [img]="ClipboardListIcon" [size]="16"></lucide-icon>
      </span>
      <h1 class="title m-0">Open Access Applications</h1>
    </div>
    <button class="btn btn-outline-secondary btn-sm d-inline-flex align-items-center gap-2" type="button" (click)="router.navigateByUrl('/applications')">
      <lucide-icon [img]="ArrowLeftIcon" [size]="14"></lucide-icon>
      BACK TO MODE SELECTION
    </button>
  </div>

  <div class="row g-3">
    <div class="col-12 col-xl-8">
      <div class="panel">
        <div class="panel-head d-flex align-items-center gap-2">
          <lucide-icon [img]="FilePlusIcon" [size]="16"></lucide-icon>
          Basic Details
        </div>
        <div class="panel-body">
          <div class="row g-2">
            <div class="col-md-3">
              <label class="input-label">Contract <span class="req">*</span></label>
              <div class="corridor-select" (click)="toggleContractDropdown($event)">
                <button type="button" class="form-select form-select-sm d-flex align-items-center justify-content-between text-start">
                  <span class="corridor-label">{{ selectedContractLabel() }}</span>
                  <lucide-icon [img]="ChevronDownIcon" [size]="14"></lucide-icon>
                </button>
                @if (contractDropdownOpen()) {
                  <div class="corridor-dropdown" (click)="onContractPanelClick($event)">
                    <div class="corridor-search-wrap">
                      <lucide-icon class="corridor-search-icon" [img]="SearchIcon" [size]="14"></lucide-icon>
                      <input
                        type="text"
                        class="form-control form-control-sm corridor-search"
                        placeholder="Search contract"
                        [ngModel]="contractSearch()"
                        (ngModelChange)="onContractSearchChange($event)"
                        name="contractSearch"
                      />
                    </div>
                    <div class="corridor-list">
                      @for (contract of filteredApprovedContracts(); track contract.id) {
                        <button
                          type="button"
                          class="corridor-item w-100 text-start border-0 bg-transparent"
                          (click)="selectContract(contract.id)"
                        >
                          <span>{{ contract.contract_number }}</span>
                          @if (form().contractId === contract.id) {
                            <lucide-icon [img]="CheckIcon" [size]="13"></lucide-icon>
                          }
                        </button>
                      }
                      @if (filteredApprovedContracts().length === 0) {
                        <div class="corridor-empty">No contract found</div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="col-md-3">
              <label class="input-label">Application No <span class="req">*</span></label>
              <input class="form-control form-control-sm" [ngModel]="form().applicationNumber" (ngModelChange)="patchForm({ applicationNumber: $event })" name="applicationNumber" placeholder="Application No" />
            </div>
            <div class="col-md-3">
              <label class="input-label">Application Type <span class="req">*</span></label>
              <select class="form-select form-select-sm" [ngModel]="form().applicationType" (ngModelChange)="patchForm({ applicationType: $event })" name="applicationType">
                <option value="" disabled>Select Application Type</option>
                @for (item of applicationTypeOptions; track item) {
                  <option [value]="item">{{ item }}</option>
                }
              </select>
            </div>
            <div class="col-md-3">
              <label class="input-label">Application Date <span class="req">*</span></label>
              <input class="form-control form-control-sm" type="date" [ngModel]="form().applicationDate" (ngModelChange)="patchForm({ applicationDate: $event })" name="applicationDate" />
            </div>

            <div class="col-md-3">
              <label class="input-label">GTAM Transaction <span class="req">*</span></label>
              <select class="form-select form-select-sm" [ngModel]="form().gtamTransaction" (ngModelChange)="onGtamChange($event)" name="gtamTransaction">
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
            <div class="col-md-3">
              <label class="input-label">
                Generator Source
                @if (isGeneratorSourceMandatory()) {
                  <span class="req">*</span>
                }
              </label>
              <select class="form-select form-select-sm" [ngModel]="form().generationSource" (ngModelChange)="patchForm({ generationSource: $event })" [disabled]="!isGeneratorSourceMandatory()" name="generationSource">
                <option value="" disabled>Select Generation type</option>
                @for (item of generationSourceOptions; track item) {
                  <option [value]="item">{{ item }}</option>
                }
              </select>
              @if (isGeneratorSourceMandatory() && !form().generationSource) {
                <div class="required-hint mt-1">Generator Source is mandatory for GTAM = Yes.</div>
              }
            </div>
            <div class="col-md-3">
              <label class="input-label">Corridor <span class="req">*</span></label>
              <div class="corridor-select" (click)="toggleCorridorDropdown($event)">
                <button type="button" class="form-select form-select-sm d-flex align-items-center justify-content-between text-start">
                  <span class="corridor-label">{{ selectedCorridorLabel() }}</span>
                  <lucide-icon [img]="ChevronDownIcon" [size]="14"></lucide-icon>
                </button>
                @if (corridorOpen()) {
                  <div class="corridor-dropdown" (click)="onCorridorPanelClick($event)">
                    <div class="corridor-search-wrap">
                      <lucide-icon class="corridor-search-icon" [img]="SearchIcon" [size]="14"></lucide-icon>
                      <input
                        type="text"
                        class="form-control form-control-sm corridor-search"
                        placeholder="Search route"
                        [ngModel]="corridorSearch()"
                        (ngModelChange)="onCorridorSearchChange($event)"
                        name="corridorSearch"
                      />
                    </div>
                    <div class="corridor-list">
                      @for (route of filteredRoutes(); track route.value) {
                        <label class="corridor-item">
                          <input
                            type="checkbox"
                            [checked]="isCorridorSelected(route.value)"
                            (change)="toggleCorridor(route.value, $any($event.target).checked)"
                          />
                          <span>{{ route.label }}</span>
                          @if (isCorridorSelected(route.value)) {
                            <lucide-icon [img]="CheckIcon" [size]="13"></lucide-icon>
                          }
                        </label>
                      }
                      @if (filteredRoutes().length === 0) {
                        <div class="corridor-empty">No route found</div>
                      }
                    </div>
                  </div>
                }
              </div>
            </div>
            <div class="col-md-3">
              <label class="input-label">UTR Number <span class="req">*</span></label>
              <input class="form-control form-control-sm" [ngModel]="form().utrNumber" (ngModelChange)="patchForm({ utrNumber: $event })" name="utrNumber" placeholder="UTR Number" />
            </div>

            <div class="col-md-6">
              <label class="input-label">Remarks Format 1</label>
              <input class="form-control form-control-sm" [ngModel]="form().remarks1" (ngModelChange)="patchForm({ remarks1: $event })" name="remarks1" />
            </div>
            <div class="col-md-6">
              <label class="input-label">Remarks Format 2</label>
              <input class="form-control form-control-sm" [ngModel]="form().remarks2" (ngModelChange)="patchForm({ remarks2: $event })" name="remarks2" />
            </div>
          </div>

          <div class="tip-box">
            <b>Tip:</b> Contract dropdown shows only approved contracts. Seller/Buyer entity and LOA options are auto-filtered from linked party details of selected contract.
          </div>
        </div>
      </div>

      <div class="row g-2 mt-2">
        <div class="col-md-6">
          <div class="entity-card">
            <div class="entity-head">Seller Details</div>
            <div class="entity-body seller">
              <div class="mb-2">
                <select class="form-select form-select-sm" [ngModel]="form().sellerVendorId" (ngModelChange)="onSellerVendorChange($event)" name="sellerVendorId">
                  <option value="" disabled>Select Entity</option>
                  @for (vendor of sellerVendorOptions(); track vendor.id) {
                    <option [value]="vendor.id">{{ vendor.vendor_name }}</option>
                  }
                </select>
              </div>
              <div class="mb-1">
                <select class="form-select form-select-sm" [ngModel]="form().sellerLoaId" (ngModelChange)="patchForm({ sellerLoaId: $event })" name="sellerLoaId">
                  <option value="" disabled>Select LOI</option>
                  @for (loa of sellerLoaOptions(); track loa.id) {
                    <option [value]="loa.id">{{ loa.loa_number }}</option>
                  }
                </select>
              </div>
              <div class="meta-text">
                Type: Seller<br />
                SLDC / RLDC : {{ partyMeta('seller').sldc || '-' }} / {{ partyMeta('seller').rldc || '-' }}<br />
                Injection Point : {{ partyMeta('seller').injection_point || '-' }}<br />
                Entity Embedded : {{ formatEmbedded(partyMeta('seller').is_embedded) }}
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="entity-card">
            <div class="entity-head d-flex justify-content-between align-items-center">
              <span>Buyer Details</span>
              <lucide-icon [img]="ArrowRightLeftIcon" [size]="15"></lucide-icon>
            </div>
            <div class="entity-body buyer">
              <div class="mb-2">
                <select class="form-select form-select-sm" [ngModel]="form().buyerVendorId" (ngModelChange)="onBuyerVendorChange($event)" name="buyerVendorId">
                  <option value="" disabled>Select Entity</option>
                  @for (vendor of buyerVendorOptions(); track vendor.id) {
                    <option [value]="vendor.id">{{ vendor.vendor_name }}</option>
                  }
                </select>
              </div>
              <div class="mb-1">
                <select class="form-select form-select-sm" [ngModel]="form().buyerLoaId" (ngModelChange)="onBuyerLoaChange($event)" name="buyerLoaId">
                  <option value="" disabled>Select LOI</option>
                  @for (loa of buyerLoaOptions(); track loa.id) {
                    <option [value]="loa.id">{{ loa.loa_number }}</option>
                  }
                </select>
              </div>
              <div class="meta-text">
                Type: Buyer<br />
                SLDC / RLDC : {{ partyMeta('buyer').sldc || '-' }} / {{ partyMeta('buyer').rldc || '-' }}<br />
                Withdrawal Point : {{ partyMeta('buyer').injection_point || '-' }}<br />
                Entity Embedded : {{ formatEmbedded(partyMeta('buyer').is_embedded) }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mt-2">
        <div class="schedule-head d-flex justify-content-between align-items-center">
          <div>
            <div class="d-flex align-items-center gap-1 fw-bold fs-5">
              <lucide-icon [img]="ArrowRightLeftIcon" [size]="15"></lucide-icon>
              Scheduled
            </div>
          </div>
          <button class="btn-add d-inline-flex align-items-center gap-1" type="button" [disabled]="!canEditSchedule()" (click)="openScheduleModal()">
            <lucide-icon [img]="PlusIcon" [size]="14"></lucide-icon>
            ADD SCHEDULE
          </button>
        </div>
        <div class="table-wrap rounded-top-0">
          <div class="table-responsive">
            <table class="table table-sm grid-table mb-0">
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>From Date</th>
                  <th>To Date</th>
                  <th>From Time</th>
                  <th>To Time</th>
                  <th>Quantum (MW)</th>
                  <th>Arrangement</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                @if (scheduleRows().length === 0) {
                  <tr>
                    <td colspan="8" class="text-center py-5 text-muted fw-semibold">No Data Found</td>
                  </tr>
                }
                @for (row of scheduleRows(); track row.id; let i = $index) {
                  <tr>
                    <td>{{ i + 1 }}</td>
                    <td>{{ row.fromDate }}</td>
                    <td>{{ row.toDate }}</td>
                    <td>{{ row.fromTime }}</td>
                    <td>{{ row.toTime }}</td>
                    <td>{{ row.quantum }}</td>
                    <td>{{ row.arrangement }}</td>
                    <td>
                      <button type="button" class="btn btn-light btn-sm me-1" [disabled]="!canEditSchedule()" (click)="editSchedule(row.id)">Edit</button>
                      <button type="button" class="btn btn-light btn-sm" [disabled]="!canEditSchedule()" (click)="removeSchedule(row.id)">
                        <lucide-icon [img]="Trash2Icon" [size]="13"></lucide-icon>
                      </button>
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 col-xl-4">
      <div class="panel h-100">
        <div class="panel-head">Contract Details</div>
        <div class="panel-body">
          <div class="small fw-semibold">Progress</div>
          <div class="progress-bar-lite mb-2">
            <div class="progress-bar-lite-fill" [style.width.%]="contractPunchProgressPercent()"></div>
          </div>
          <div class="fw-semibold">Validity : {{ formatContractDate(selectedContract()?.period_from) }} to {{ formatContractDate(selectedContract()?.period_to) }}</div>
          <div class="fw-semibold">Total Quantum : {{ selectedContractQuantumMwh() }} MWh</div>
          <div class="fw-semibold">Already Punched : {{ alreadyPunchedQuantumMwh() }} MWh</div>
          <div class="fw-semibold mb-3">Remaining to Punch : {{ remainingToPunchQuantumMwh() }} MWh</div>

          <div class="fw-bold mb-1">Application Punched</div>
          <div class="table-wrap mb-3">
            <table class="table table-sm grid-table mb-0">
              <thead><tr><th>Date</th><th>Quantum</th><th>Status</th></tr></thead>
              <tbody>
                @if (punchedApplicationsSummary().length) {
                  @for (row of punchedApplicationsSummary(); track row.date + '-' + row.quantum + '-' + row.status) {
                    <tr>
                      <td>{{ formatContractDate(row.date) }}</td>
                      <td>{{ row.quantum }}</td>
                      <td class="text-capitalize">{{ row.status }}</td>
                    </tr>
                  }
                } @else {
                  <tr><td colspan="3" class="text-center text-muted py-3">-</td></tr>
                }
              </tbody>
            </table>
          </div>

          <div class="fw-bold mb-1">Seller Schedule :</div>
          <div class="table-wrap mb-3">
            <table class="table table-sm grid-table mb-0">
              <thead><tr><th>From Date</th><th>To Date</th><th>From Time</th><th>To Time</th><th>Quantum</th></tr></thead>
              <tbody>
                @if (sellerScheduleSummary().length) {
                  @for (row of sellerScheduleSummary(); track row.fromDate + '-' + row.toDate + '-' + row.fromTime + '-' + row.toTime + '-' + row.quantum) {
                    <tr>
                      <td>{{ formatContractDate(row.fromDate) }}</td>
                      <td>{{ formatContractDate(row.toDate) }}</td>
                      <td>{{ row.fromTime }}</td>
                      <td>{{ row.toTime }}</td>
                      <td>{{ row.quantum }}</td>
                    </tr>
                  }
                } @else {
                  <tr><td colspan="5" class="text-center text-muted py-3">-</td></tr>
                }
              </tbody>
            </table>
          </div>

          <div class="fw-bold mb-1">Buyer Schedule :</div>
          <div class="table-wrap">
            <table class="table table-sm grid-table mb-0">
              <thead><tr><th>From Date</th><th>To Date</th><th>From Time</th><th>To Time</th><th>Quantum</th></tr></thead>
              <tbody>
                @if (buyerScheduleSummary().length) {
                  @for (row of buyerScheduleSummary(); track row.fromDate + '-' + row.toDate + '-' + row.fromTime + '-' + row.toTime + '-' + row.quantum) {
                    <tr>
                      <td>{{ formatContractDate(row.fromDate) }}</td>
                      <td>{{ formatContractDate(row.toDate) }}</td>
                      <td>{{ row.fromTime }}</td>
                      <td>{{ row.toTime }}</td>
                      <td>{{ row.quantum }}</td>
                    </tr>
                  }
                } @else {
                  <tr><td colspan="5" class="text-center text-muted py-3">-</td></tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="action-row page-bottom-actions d-flex justify-content-end">
    @if (generatedApplicationId()) {
      <button class="btn btn-outline-primary btn-sm me-2" type="button" (click)="generateFormatD()">GENERATE FORMAT-D</button>
    }
    <button class="btn btn-primary btn-sm" type="button" [disabled]="isSaving()" (click)="submit()">{{ isSaving() ? 'SAVING...' : 'SAVE APPLICATION' }}</button>
  </div>

  @if (scheduleModalOpen()) {
    <div class="modal-backdrop-lite" (click)="closeScheduleModal()"></div>
    <div class="schedule-modal" role="dialog" aria-modal="true">
      <div class="schedule-modal-head d-flex justify-content-between align-items-center">
        <div class="schedule-modal-title">{{ editingScheduleId() === null ? 'Import Scheduled' : 'Edit Scheduled' }}</div>
        <button type="button" class="btn-close-square" (click)="closeScheduleModal()">
          <lucide-icon [img]="XIcon" [size]="14"></lucide-icon>
        </button>
      </div>
      <div class="schedule-modal-body">
        <div class="row g-2">
          <div class="col-md-6">
            <label class="input-label">From Date <span class="req">*</span></label>
            <input type="date" class="form-control form-control-sm" [ngModel]="scheduleForm().fromDate" (ngModelChange)="patchScheduleForm({ fromDate: $event })" name="scheduleFromDate" />
          </div>
          <div class="col-md-6">
            <label class="input-label">To Date <span class="req">*</span></label>
            <input type="date" class="form-control form-control-sm" [ngModel]="scheduleForm().toDate" (ngModelChange)="patchScheduleForm({ toDate: $event })" name="scheduleToDate" />
          </div>
          <div class="col-md-6">
            <label class="input-label">From Time <span class="req">*</span></label>
            <select class="form-select form-select-sm" [ngModel]="scheduleForm().fromTime" (ngModelChange)="patchScheduleForm({ fromTime: $event })" name="scheduleFromTime">
              <option value="" disabled>Select Time</option>
              @for (item of timeOptions; track item) {
                <option [value]="item">{{ item }}</option>
              }
            </select>
          </div>
          <div class="col-md-6">
            <label class="input-label">To Time <span class="req">*</span></label>
            <select class="form-select form-select-sm" [ngModel]="scheduleForm().toTime" (ngModelChange)="patchScheduleForm({ toTime: $event })" name="scheduleToTime">
              <option value="" disabled>Select Time</option>
              @for (item of timeOptions; track item) {
                <option [value]="item">{{ item }}</option>
              }
            </select>
          </div>
          <div class="col-md-6">
            <label class="input-label">Quantum (MW) <span class="req">*</span></label>
            <input type="number" min="0" step="0.01" class="form-control form-control-sm" [ngModel]="scheduleForm().quantum" (ngModelChange)="patchScheduleForm({ quantum: $event })" name="scheduleQuantum" placeholder="Quantum (MW)" />
          </div>
          <div class="col-md-6">
            <label class="input-label">Arrangement</label>
            <input type="number" min="1" step="1" class="form-control form-control-sm" [ngModel]="scheduleForm().arrangement" (ngModelChange)="patchScheduleForm({ arrangement: $event })" name="scheduleArrangement" />
          </div>
        </div>
        <div class="d-flex justify-content-end gap-2 mt-3">
          <button type="button" class="btn btn-outline-secondary btn-sm px-3" (click)="closeScheduleModal()">CANCEL</button>
          <button type="button" class="btn btn-primary btn-sm px-3" (click)="addSchedule()">{{ editingScheduleId() === null ? 'ADD' : 'UPDATE' }}</button>
        </div>
      </div>
    </div>
  }
</div>
